export default __webpack_public_path__ + "static/ogp-aa3bdc542b2e594a485689ea2b22ff2f.png";